<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.0104 16.5651H18.4411C19.0721 16.565 19.6407 16.1838 19.8803 15.6C20.1199 15.0163 19.9832 14.3455 19.5341 13.9022L11.0386 5.51472C10.5264 5.00904 9.76055 4.86053 9.09646 5.13809C8.43237 5.41566 8.00001 6.06497 8 6.78473V18.4376C8.00002 19.0638 8.37548 19.6289 8.95272 19.8717C9.52996 20.1144 10.1965 19.9874 10.644 19.5494L13.4662 16.787C13.6116 16.6447 13.807 16.5651 14.0104 16.5651Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
